import React, { memo, useContext, useMemo } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableFooter,
  TableHead,
  Divider,
  TextField,
  alpha,
  TableRow,
  TableCell,
  CircularProgress,
} from "@mui/material";
import {
  Menu,
  Outbox,
  ListRounded,
  MenuBook,
  LocalGasStation,
  PictureAsPdf,
} from "@mui/icons-material";

import useFacturacion from "./useFacturacion";
import { columns, ESTADOS, ESTADOS_NEIMAR, CAMPO_EXPORT } from "./constants";
import ToolbarCRUD from "../../components/newFormat/ToolbarCRUD";
import TablaHeader from "../../components/newFormat/TablaHeaderCRUD";
import {
  LoadingRow,
  EmptyRow,
} from "../../components/newFormat/TableEmptyStates";
import { tableContainerSx } from "../../components/newFormat/styles";
import Row from "./Componentes/Row";
import Modal from "./Componentes/Modal";

import FiltrosFacturacion from "./Componentes/FiltrosFacturacion";
import ModalInventario from "../../Configuración/Inventario/Componentes/Modal";
import ModalProveedor from "../../Compras/Proveedores/Personas_Contable/Componentes/Modal";
import ModalProveedorISP from "../../Compras/Proveedores/Personas_ISP/Componentes/Modal";
import ModalProveedorVet from "../../Veterinaria/Personas_Veterinaria/Componentes/Modal";
import ModalTraido from "./ModalTraido";
import Categorias from "../../Configuración/Categorias/Categorias";
import Subcategorias from "../../Configuración/Subcategorias/Subcategorias";
import DialogOpciones from "../../components/Dialogs/DialogOpciones";

import AuthContext from "../../../Context/Auth/AuthContext";
import AlertaContext from "../../../Context/Alerta/AlertaContext";

const tabBtnSx = (active) => ({
  px: 1.5,
  py: 0.3,
  borderRadius: "12px 12px 0 0",
  fontSize: "0.7rem",
  fontWeight: active ? 700 : 500,
  textTransform: "none",
  minWidth: "auto",
  ...(active
    ? {
        boxShadow: (t) => `0 2px 8px ${alpha(t.palette.primary.main, 0.3)}`,
      }
    : {
        borderColor: "divider",
        color: "text.secondary",
      }),
});

const Facturacion = (props) => {
  const { usuario } = useContext(AuthContext);
  const { mostrarAlerta } = useContext(AlertaContext);

  const {
    rows,
    pagination,
    page,
    rowsPerPage,
    search,
    buscando,
    input,
    orden,
    cargando,
    highlightId,
    highlightType,
    totalPages,
    estadoRequest,
    open,
    editar,
    objectoActivo,
    filtros,
    tieneFiltros,
    ocultarAgregar,
    openProveedor,
    openProveedorModalI,
    editarProveedor,
    openInventario,
    editarInventario,
    openCategoria,
    openSubCategoria,
    openDialogOpciones,
    openExportDialog,
    mesExport,
    objectoActivoInventario,
    objectoActivoProveedor,
    arrayExport,
    socket,
    reducer,
    tienePermiso,
    alertaPermiso,
    desdeOtroLugarPersona,
    inputTxtSri,
    inputXmlSri,
    setSearch,
    handleSearch,
    handleSort,
    handleChangePage,
    handleChangeRowsPerPage,
    handleRefresh,
    handleClearSearch,
    setOpen,
    setEditar,
    changeObjetoActivoState,
    handleOpenNuevo,
    editarState,
    handleChangeEstadoRequest,
    handleFiltrosChange,
    handleClearFiltros,
    funcArchivoTxtSri,
    funcArchivoXmlSri,
    handleAutorizarPorLote,
    funcPdfExport,
    funcExcelExport,
    funcExcelRecaudaciones,
    funcExcelVentaGas,
    funcCierreVentas,
    cargandoCierre,
    cargandoVentaGas,
    setOpenProveedor,
    setOpenProveedorModalI,
    setEditarProveedor,
    setOpenInventario,
    setEditarInventario,
    setOpenCategoria,
    setOpenSubCategoria,
    setOpenDialogOpciones,
    setOpenExportDialog,
    setMesExport,
    setArrayExport,
    changeObjetoActivoStateInventario,
    changeObjetoActivoStateProveedor,
  } = useFacturacion(props);

  const tieneFiltrosVentaGas = useMemo(
    () =>
      !!(
        filtros.venNumFactura ||
        filtros.venRucCliente ||
        filtros.venFechaFactura1 ||
        filtros.venFechaFactura2 ||
        filtros.venUser ||
        filtros.venFecReg1 ||
        filtros.venFecReg2
      ),
    [filtros.venNumFactura, filtros.venRucCliente, filtros.venFechaFactura1, filtros.venFechaFactura2, filtros.venUser, filtros.venFecReg1, filtros.venFecReg2],
  );

  const tieneCierreVentas = useMemo(
    () => !!(filtros.venUser && filtros.horarios),
    [filtros.venUser, filtros.horarios],
  );

  const handleVentaGas = () => {
    if (!tieneFiltrosVentaGas) {
      mostrarAlerta(
        "Seleccione al menos un filtro: Documento, RUC, F. Factura, F. Registro o Usuario",
        "warning",
      );
      return;
    }
    funcExcelVentaGas();
  };

  const totalDisplayed = rows
    ? rows.reduce((sum, r) => sum + (parseFloat(r.venTotal) || 0), 0)
    : 0;
  const totalSelected = rows
    ? rows
        .filter((r) => arrayExport.includes(r[CAMPO_EXPORT]))
        .reduce((sum, r) => sum + (parseFloat(r.venTotal) || 0), 0)
    : 0;

  const fmtTotal = (val) =>
    val.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <Box>
      <ModalTraido
        open={openCategoria}
        setopen={setOpenCategoria}
        titulo="Categoría"
        Componente={Categorias}
        socket={socket}
      />
      <ModalTraido
        open={openSubCategoria}
        setopen={setOpenSubCategoria}
        titulo="Sub Categoría"
        Componente={Subcategorias}
        socket={socket}
      />
      <ModalProveedor
        estadoRequest={"PROVEEDOR"}
        open={openProveedorModalI}
        setopen={setOpenProveedorModalI}
        editar={editarProveedor}
        seteditar={setEditarProveedor}
        socket={socket}
        ObjectoActivo={objectoActivoProveedor}
        changeObjetoActivoState={changeObjetoActivoStateProveedor}
      />
      {(usuario.empCategoria === "CONTABLE" ||
        usuario.empCategoria === "GASOLINERA") && (
        <ModalProveedor
          estadoRequest={"CLIENTE"}
          open={openProveedor}
          setopen={setOpenProveedor}
          editar={editarProveedor}
          seteditar={setEditarProveedor}
          socket={socket}
          ObjectoActivo={objectoActivoProveedor}
          changeObjetoActivoState={changeObjetoActivoStateProveedor}
        />
      )}
      {usuario.empCategoria === "ISP" && (
        <ModalProveedorISP
          estadoRequest={"CLIENTE"}
          open={openProveedor}
          setopen={setOpenProveedor}
          editar={editarProveedor}
          seteditar={setEditarProveedor}
          socket={socket}
          ObjectoActivo={objectoActivoProveedor}
          changeObjetoActivoState={changeObjetoActivoStateProveedor}
        />
      )}
      {usuario.empCategoria === "VETERINARIA" && (
        <ModalProveedorVet
          estadoRequest={"CLIENTE"}
          open={openProveedor}
          setopen={setOpenProveedor}
          editar={editarProveedor}
          seteditar={setEditarProveedor}
          socket={socket}
          ObjectoActivo={objectoActivoProveedor}
          changeObjetoActivoState={changeObjetoActivoStateProveedor}
        />
      )}
      {socket.current && (
        <ModalInventario
          open={openInventario}
          setopen={setOpenInventario}
          editar={editarInventario}
          seteditar={setEditarInventario}
          setopenSubCategoria={setOpenSubCategoria}
          setopenCategoria={setOpenCategoria}
          setOpenProveedor={setOpenProveedorModalI}
          ObjectoActivo={objectoActivoInventario}
          changeObjetoActivoState={changeObjetoActivoStateInventario}
          socket={socket}
          seteditarProveedor={setEditarProveedor}
          changeObjetoActivoStateProveedor={changeObjetoActivoStateProveedor}
        />
      )}

      <input
        style={{ display: "none" }}
        type="file"
        accept=".txt"
        onChange={funcArchivoTxtSri}
        ref={inputTxtSri}
      />
      <input
        multiple
        style={{ display: "none" }}
        type="file"
        onChange={funcArchivoXmlSri}
        ref={inputXmlSri}
      />

      <DialogOpciones
        open={openDialogOpciones}
        setopen={setOpenDialogOpciones}
        botones={[
          {
            tooltip: "Subir TXT SRI (Retenciones)",
            funcion: () => inputTxtSri.current.click(),
            Icon: Outbox,
            color: "primary",
            id: 1,
            disabled: false,
          },
          {
            tooltip: "Subir XML (Retención)",
            funcion: () => inputXmlSri.current.click(),
            Icon: Outbox,
            color: "primary",
            id: 2,
            disabled: false,
          },
          {
            tooltip: "Autorizar Por lote",
            funcion: handleAutorizarPorLote,
            Icon: Outbox,
            color: "primary",
            id: 3,
            disabled: false,
          },
        ]}
        titulo={"Mas Opciones"}
      />

      <DialogOpciones
        open={openExportDialog}
        setopen={setOpenExportDialog}
        titulo="Exportar"
        botones={[
          {
            tooltip: "Excel (Selección)",
            funcion: funcExcelExport,
            Icon: MenuBook,
            color: "primary",
            id: 1,
            disabled: cargando || arrayExport.length === 0,
          },
          {
            tooltip: "Excel (Mensual)",
            funcion: () => funcExcelExport(mesExport),
            Icon: MenuBook,
            color: "primary",
            id: 2,
            disabled: cargando || mesExport === "",
          },
          {
            tooltip: "BP_CASH",
            funcion: funcExcelRecaudaciones,
            Icon: MenuBook,
            color: "primary",
            id: 4,
            disabled: cargando || arrayExport.length === 0,
          },
        ]}
      >
        <TextField
          InputLabelProps={{ shrink: true }}
          label="Mes"
          type="month"
          value={mesExport}
          onChange={(e) => setMesExport(e.target.value)}
          fullWidth
          size="small"
          sx={{ mt: 1 }}
        />
      </DialogOpciones>

      <ToolbarCRUD
        labelAgregar="Agregar"
        placeholderBuscar="Buscar por documento, cliente, estado..."
        search={search}
        setSearch={setSearch}
        buscando={buscando}
        onSearch={handleSearch}
        onClearSearch={handleClearSearch}
        onRefresh={handleRefresh}
        onNuevo={ocultarAgregar ? undefined : handleOpenNuevo}
        cargando={cargando}
        openNuevo={false}
        editandoId={null}
        pagination={pagination}
        page={page}
        totalPages={totalPages}
        rowsPerPage={rowsPerPage}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        botonesExtra={[
          {
            tooltip: "Opciones",
            funcion: () => setOpenDialogOpciones(true),
            disabled: false,
            Icon: Menu,
            color: "secondary",
            id: "opciones",
            ocultar: ocultarAgregar,
            tipo: "icono",
            variante: "contained",
            size: "small",
            sx: {},
          },
          {
            tooltip: "Exportar",
            funcion: () => setOpenExportDialog(true),
            disabled: false,
            Icon: ListRounded,
            color: "primary",
            id: "export",
            ocultar: false,
            tipo: "icono",
            variante: "contained",
            size: "small",
            sx: {},
          },
          {
            tooltip: cargandoVentaGas
              ? "Generando..."
              : tieneFiltrosVentaGas
                ? "Venta Gas"
                : "Venta Gas (requiere filtros)",
            funcion: handleVentaGas,
            disabled: cargando || cargandoVentaGas,
            Icon: cargandoVentaGas
              ? () => <CircularProgress size={16} />
              : LocalGasStation,
            color: cargandoVentaGas ? "inherit" : "primary",
            id: "ventagas",
            ocultar: false,
            tipo: "icono",
            variante: "contained",
            size: "small",
            sx: tieneFiltrosVentaGas
              ? {}
              : {
                  animation: "pulse 2s infinite",
                  "@keyframes pulse": {
                    "0%": { opacity: 1 },
                    "50%": { opacity: 0.6 },
                    "100%": { opacity: 1 },
                  },
                },
          },
          {
            tooltip: cargandoCierre
              ? "Generando..."
              : tieneCierreVentas
                ? "Cierre Ventas"
                : "Cierre Ventas (requiere usuario y horario)",
            funcion: funcCierreVentas,
            disabled: cargando || cargandoCierre,
            Icon: cargandoCierre
              ? () => <CircularProgress size={16} />
              : PictureAsPdf,
            color: cargandoCierre ? "inherit" : "error",
            id: "cierreventas",
            ocultar: false,
            tipo: "icono",
            variante: "contained",
            size: "small",
            sx: tieneCierreVentas
              ? {}
              : {
                  animation: "pulse 2s infinite",
                  "@keyframes pulse": {
                    "0%": { opacity: 1 },
                    "50%": { opacity: 0.6 },
                    "100%": { opacity: 1 },
                  },
                },
          },
        ]}
      />

      <FiltrosFacturacion
        filtros={filtros}
        onFiltrosChange={handleFiltrosChange}
        onClearFiltros={handleClearFiltros}
        cargando={cargando}
      />

      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="stretch"
        width="100%"
        mb={0}
      >
        {ESTADOS.map((boton) => (
          <Button
            key={boton.estado}
            size="small"
            disabled={cargando}
            variant={estadoRequest === boton.estado ? "contained" : null}
            onClick={() => handleChangeEstadoRequest(boton.estado)}
            disableElevation
            sx={tabBtnSx(estadoRequest === boton.estado)}
            color="primary"
          >
            {boton.label}
          </Button>
        ))}
        {usuario.rucempresa === "NEIMAR" &&
          ESTADOS_NEIMAR.map((boton) => (
            <Button
              key={boton.estado}
              size="small"
              disabled={cargando}
              variant={estadoRequest === boton.estado ? "contained" : null}
              onClick={() => handleChangeEstadoRequest(boton.estado)}
              disableElevation
              sx={tabBtnSx(estadoRequest === boton.estado)}
              color="primary"
            >
              {boton.label}
            </Button>
          ))}
      </Box>
      <Divider />

      <TableContainer component={Paper} elevation={0} sx={tableContainerSx}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TablaHeader
              columns={columns}
              cargando={cargando}
              input={input}
              orden={orden}
              onSort={handleSort}
              seleccionable={true}
              allSelected={
                rows?.length > 0 &&
                rows.every((r) => arrayExport.includes(r[CAMPO_EXPORT]))
              }
              someSelected={
                !(
                  rows?.length > 0 &&
                  rows.every((r) => arrayExport.includes(r[CAMPO_EXPORT]))
                ) && rows?.some((r) => arrayExport.includes(r[CAMPO_EXPORT]))
              }
              onToggleSelectAll={() => {
                if (!rows) return;
                const pageIds = rows.map((r) => r[CAMPO_EXPORT]);
                if (pageIds.every((id) => arrayExport.includes(id))) {
                  setArrayExport(
                    arrayExport.filter((id) => !pageIds.includes(id)),
                  );
                } else {
                  setArrayExport([...new Set([...arrayExport, ...pageIds])]);
                }
              }}
            />
          </TableHead>
          <TableBody>
            {!rows ? (
              <LoadingRow colSpan={columns.length + 2} />
            ) : rows.length === 0 ? (
              <EmptyRow colSpan={columns.length + 2} />
            ) : (
              rows.map((row, idx) => (
                <Row
                  campoExport={CAMPO_EXPORT}
                  rows={rows}
                  seteditar={setEditar}
                  arrayExport={arrayExport}
                  setarrayExport={setArrayExport}
                  row={row}
                  index={idx}
                  setopen={setOpen}
                  key={row[CAMPO_EXPORT] || idx}
                  socket={socket}
                  ObjectoActivo={objectoActivo}
                  changeObjetoActivoState={changeObjetoActivoState}
                  alertaPermiso={alertaPermiso}
                  tienePermiso={tienePermiso}
                  editarState={editarState}
                />
              ))
            )}
          </TableBody>
          {rows && rows.length > 0 && (
            <TableFooter>
              <TableRow
                sx={{
                  "& td": {
                    py: 1,
                    fontSize: "0.72rem",
                    fontWeight: 600,
                    borderTop: "2px solid",
                    borderColor: "divider",
                    bgcolor: (t) => alpha(t.palette.primary.main, 0.04),
                  },
                }}
              >
                <TableCell colSpan={7} />
                <TableCell
                  colSpan={2}
                  align="right"
                  sx={{ whiteSpace: "nowrap" }}
                >
                  <Box
                    component="span"
                    sx={{
                      display: "inline-flex",
                      alignItems: "right",
                      gap: 0.5,
                      px: 1.2,
                      py: 0.3,
                      borderRadius: 1,
                      bgcolor: (t) =>
                        totalSelected > 0
                          ? alpha(t.palette.success.main, 0.08)
                          : "transparent",
                      transition: "background-color 0.3s",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ color: "text.secondary", fontWeight: 500 }}
                    >
                      Selec.
                    </Box>
                    <Box
                      component="span"
                      sx={{
                        fontWeight: 700,
                        fontSize: "0.78rem",
                        color:
                          totalSelected > 0 ? "success.main" : "text.disabled",
                        transition: "color 0.3s",
                      }}
                    >
                      ${fmtTotal(totalSelected)}
                    </Box>
                    <Box
                      component="span"
                      sx={{ color: "text.disabled", mx: 0.2 }}
                    >
                      /
                    </Box>
                    <Box
                      component="span"
                      sx={{
                        color: "primary.main",
                        fontWeight: 700,
                        fontSize: "0.78rem",
                      }}
                    >
                      ${fmtTotal(totalDisplayed)}
                    </Box>
                  </Box>
                </TableCell>
                <TableCell colSpan={6} />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>

      {socket.current && (
        <Modal
          estadoRequest={estadoRequest}
          editar={editar}
          seteditar={setEditar}
          setopen={setOpen}
          open={open}
          setopenInventario={setOpenInventario}
          setOpenProveedor={setOpenProveedor}
          ObjectoActivo={objectoActivo}
          changeObjetoActivoState={changeObjetoActivoState}
          socket={socket}
          seteditarInventario={setEditarInventario}
          changeObjetoActivoStateInventario={changeObjetoActivoStateInventario}
          seteditarProveedor={setEditarProveedor}
          changeObjetoActivoStateProveedor={changeObjetoActivoStateProveedor}
        />
      )}
    </Box>
  );
};

export default memo(Facturacion);
